module.exports = __webpack_public_path__ + "static/media/ph_meter_obtained.11e9c8de.svg";